<template>
    <div>
        <spinner/>
        <q-layout :view="layout">

            <!-- Navbar -->
            <q-layout-header :reveal="!this.$breakpoints.isGreaterThan('sm')">
                <v-header @rightDrawerToogle="right = !right"/>
            </q-layout-header>

            <!-- Right Side Panel -->
            <q-layout-drawer side="right" v-model="right" behavior="mobile">
                <v-menu/>
            </q-layout-drawer>

            <!-- Content -->
            <q-page-container>
                <router-view/>
            </q-page-container>

            <!-- Footer -->
            <q-layout-footer :reveal="!this.$breakpoints.isGreaterThan('sm')">
                <v-footer/>
            </q-layout-footer>

        </q-layout>
    </div>
</template>

<script>
    import VHeader from '../components/Header'
    import VMenu from '../components/Menu'
    import VFooter from '../components/Footer'
    import VLogin from '../pages/auth/login'

    import {
        QLayout,
        QLayoutHeader,
        QLayoutDrawer,
        QLayoutFooter,
        QPageContainer,
    } from 'quasar-framework'
    import Spinner from "../components/spinner/Spinner";

    export default {
        name: 'MainLayout',

        components: {
            Spinner,
            VHeader,
            VMenu,
            VFooter,
            QLayout,
            QLayoutHeader,
            QLayoutDrawer,
            QLayoutFooter,
            QPageContainer,
        },

        data() {
            return {
                right: false,
            }
        },

        computed: {
            layout() {
                if (this.$breakpoints.isGreaterThan('sm'))
                    return 'lhr lpr lfr'
                return 'lHr lpr lFr'
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/layouts/default.vue